import { api } from '@/api'
import type { ApiPaginationResponse } from '@/api/typings/response.typing'

export interface DiscountCurrency {
  id: string
  titleFa: string
  titleEn: string
  symbol?: string
}

export interface DiscountType {
  id: number
  title: string
  titleFa: string
}

export interface DiscountUser {
  id: number
  user_id: number
  transaction_id: number | null
  used_at: string | null
  requisition_id: number | null
  offer_id: number | null
}

export interface DiscountUserInfo {
  id: number
  uuid: string
  fullName: string
  email?: string
  mobile?: string
}

export interface UserDiscount {
  id: number
  pid: number
  code: string
  title: string
  description: string | null
  rate: number
  volume_limit: number
  usage_count: number
  status: string
  status_type: string
  isUsed: boolean
  isExpired: boolean
  credit_type: string
  priority: number
  expiry_date: string | null
  createdAt: string
  last_used_at: string | null
  used_at: string | null
  discount_user: DiscountUser
  type: DiscountType
  currency: DiscountCurrency[]
  user: DiscountUserInfo[]
  offer: unknown
  requisition: unknown
}

export interface Pagination {
  currentPage: number
  lastPage: number
  perPage: number
  total: number
  hasNextPage: boolean
  hasPrevPage: boolean
}

export function getUserDiscountsAction(
  userUuid: string,
  page: number = 1
): Promise<ApiPaginationResponse<UserDiscount[]>> {
  const params = new URLSearchParams()

  params.append('page', String(page))

  const url = `/discounts/users/${userUuid}?${params.toString()}`
  return api.get<ApiPaginationResponse<UserDiscount[]>>(url)
}
